export const PHONE = '+73952261260'
export const FORMATED_PHONE = '+7 3952 261-260'
export const EMAIL = 'sales@t-code.ru'
